export default function AdminStudentList({ students = [] }) {
  return (
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>#</th>
          <th style={styles.th}>Student Name</th>
          <th style={styles.th}>Test Name</th>
          <th style={styles.th}>Score (%)</th>
          <th style={styles.th}>Grade</th>
          <th style={styles.th}>Date Attempted</th>
        </tr>
      </thead>
      <tbody>
        {students.map((s, index) => (
          <tr
            key={s.id}
            style={{
              ...styles.row,
              backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9faff",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#e8f0ff")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor =
                index % 2 === 0 ? "#ffffff" : "#f9faff")
            }
          >
            <td style={styles.td}>{index + 1}</td>
            <td style={styles.td}>{s.studentName}</td>
            <td style={styles.td}>Test{s.testNumber}</td>
            <td style={styles.td}>{s.score}%</td>
            <td style={styles.td}>{s.grade}</td>
            <td style={styles.td}>
              {new Date(s.attemptedAt).toLocaleDateString("en-GB", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
  },
  th: {
    borderBottom: "2px solid #0b3d91",
    padding: "1opx",
    textAlign: "left",
    backgroundColor: "#dbe9ff",
    color: "#0b3d91",
  },
  td: {
    padding: "1px",
    borderBottom: "1px solid #ddd",
  },
  row: {
    transition: "background-color 0.2s ease",
    cursor: "pointer",
  },
};
